package com.altmann.choresmanager.res.myiconpack

import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Brush.Companion.linearGradient
import androidx.compose.ui.graphics.Brush.Companion.radialGradient
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import com.altmann.choresmanager.res.MyAchievementsPack

public val MyAchievementsPack.Created100Achievement: ImageVector
    get() {
        if (_created100Achievement != null) {
            return _created100Achievement!!
        }
        _created100Achievement = Builder(name = "Created100Achievement", defaultWidth = 238.0.dp,
                defaultHeight = 238.0.dp, viewportWidth = 238.0f, viewportHeight = 238.0f).apply {
            path(fill = SolidColor(Color(0xFF1E1E1E)), stroke = null, strokeLineWidth = 0.0f,
                    strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                    pathFillType = NonZero) {
                moveTo(0.0f, 0.0f)
                horizontalLineToRelative(238.0f)
                verticalLineToRelative(238.0f)
                horizontalLineToRelative(-238.0f)
                close()
            }
            group {
                path(fill = SolidColor(Color(0xFF590322)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(238.0f, 0.0f)
                    horizontalLineTo(0.0f)
                    verticalLineTo(238.0f)
                    horizontalLineTo(238.0f)
                    verticalLineTo(0.0f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFFB2104B), 1.0f to Color(0xFF261903),
                        start = Offset(119.0f,-112.8f), end = Offset(119.0f,238.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(0.0f, -112.8f)
                    curveTo(10.58f, -107.18f, 42.97f, -89.66f, 63.47f, -79.09f)
                    curveTo(83.96f, -68.51f, 103.13f, -59.25f, 122.97f, -49.34f)
                    curveTo(142.8f, -39.42f, 163.29f, -28.84f, 182.47f, -19.59f)
                    curveTo(201.64f, -10.33f, 228.74f, 1.9f, 238.0f, 6.2f)
                    verticalLineTo(238.0f)
                    horizontalLineTo(0.0f)
                    verticalLineTo(-112.8f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFFB2104B), 1.0f to Color(0xFF261903),
                        start = Offset(119.0f,-46.72f), end = Offset(119.0f,238.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(0.0f, -46.72f)
                    curveTo(7.27f, -42.97f, 27.11f, -33.71f, 43.63f, -24.23f)
                    curveTo(60.16f, -14.76f, 83.3f, 0.01f, 99.17f, 10.15f)
                    curveTo(115.03f, 20.29f, 124.29f, 29.1f, 138.83f, 36.6f)
                    curveTo(153.38f, 44.09f, 169.91f, 46.96f, 186.43f, 55.11f)
                    curveTo(202.96f, 63.27f, 229.41f, 80.46f, 238.0f, 85.53f)
                    verticalLineTo(238.0f)
                    horizontalLineTo(0.0f)
                    verticalLineTo(-46.72f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFFB2104B), 1.0f to Color(0xFF261903),
                        start = Offset(119.0f,6.97f), end = Offset(119.0f,238.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(0.0f, 6.97f)
                    curveTo(8.59f, 12.48f, 36.36f, 29.68f, 51.57f, 40.04f)
                    curveTo(66.77f, 50.4f, 76.69f, 60.76f, 91.23f, 69.14f)
                    curveTo(105.78f, 77.51f, 121.64f, 81.93f, 138.83f, 90.3f)
                    curveTo(156.02f, 98.68f, 177.84f, 109.04f, 194.37f, 119.4f)
                    curveTo(210.89f, 129.76f, 230.73f, 146.96f, 238.0f, 152.47f)
                    verticalLineTo(238.0f)
                    horizontalLineTo(0.0f)
                    verticalLineTo(6.97f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xA0FFFFFF), 1.0f to Color(0x38FFFFFF),
                        start = Offset(119.0f,182.0f), end = Offset(119.0f,219.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(23.0f, 182.0f)
                    lineTo(215.0f, 182.0f)
                    arcTo(8.0f, 8.0f, 0.0f, false, true, 223.0f, 190.0f)
                    lineTo(223.0f, 211.0f)
                    arcTo(8.0f, 8.0f, 0.0f, false, true, 215.0f, 219.0f)
                    lineTo(23.0f, 219.0f)
                    arcTo(8.0f, 8.0f, 0.0f, false, true, 15.0f, 211.0f)
                    lineTo(15.0f, 190.0f)
                    arcTo(8.0f, 8.0f, 0.0f, false, true, 23.0f, 182.0f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF340000), 0.66f to Color(0xFFD80004),
                        start = Offset(116.5f,215.0f), end = Offset(116.5f,186.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(40.16f, 197.87f)
                    horizontalLineTo(35.9f)
                    curveTo(35.85f, 197.43f, 35.73f, 197.04f, 35.55f, 196.68f)
                    curveTo(35.38f, 196.33f, 35.14f, 196.03f, 34.86f, 195.78f)
                    curveTo(34.57f, 195.53f, 34.22f, 195.34f, 33.82f, 195.21f)
                    curveTo(33.43f, 195.07f, 33.0f, 195.01f, 32.52f, 195.01f)
                    curveTo(31.67f, 195.01f, 30.94f, 195.21f, 30.33f, 195.63f)
                    curveTo(29.72f, 196.04f, 29.25f, 196.64f, 28.92f, 197.43f)
                    curveTo(28.6f, 198.21f, 28.44f, 199.16f, 28.44f, 200.27f)
                    curveTo(28.44f, 201.43f, 28.6f, 202.4f, 28.93f, 203.19f)
                    curveTo(29.27f, 203.97f, 29.74f, 204.55f, 30.34f, 204.95f)
                    curveTo(30.95f, 205.34f, 31.66f, 205.54f, 32.49f, 205.54f)
                    curveTo(32.96f, 205.54f, 33.38f, 205.48f, 33.76f, 205.36f)
                    curveTo(34.15f, 205.24f, 34.49f, 205.07f, 34.78f, 204.84f)
                    curveTo(35.07f, 204.61f, 35.32f, 204.33f, 35.5f, 204.0f)
                    curveTo(35.7f, 203.66f, 35.83f, 203.28f, 35.9f, 202.86f)
                    lineTo(40.16f, 202.89f)
                    curveTo(40.09f, 203.66f, 39.87f, 204.42f, 39.49f, 205.17f)
                    curveTo(39.12f, 205.92f, 38.61f, 206.61f, 37.97f, 207.23f)
                    curveTo(37.32f, 207.84f, 36.53f, 208.33f, 35.6f, 208.69f)
                    curveTo(34.67f, 209.06f, 33.61f, 209.24f, 32.41f, 209.24f)
                    curveTo(30.83f, 209.24f, 29.41f, 208.89f, 28.16f, 208.2f)
                    curveTo(26.92f, 207.5f, 25.94f, 206.48f, 25.22f, 205.15f)
                    curveTo(24.49f, 203.81f, 24.13f, 202.19f, 24.13f, 200.27f)
                    curveTo(24.13f, 198.35f, 24.5f, 196.72f, 25.23f, 195.39f)
                    curveTo(25.97f, 194.05f, 26.96f, 193.04f, 28.21f, 192.35f)
                    curveTo(29.46f, 191.65f, 30.86f, 191.31f, 32.41f, 191.31f)
                    curveTo(33.47f, 191.31f, 34.44f, 191.46f, 35.34f, 191.75f)
                    curveTo(36.24f, 192.04f, 37.03f, 192.47f, 37.71f, 193.03f)
                    curveTo(38.39f, 193.59f, 38.95f, 194.27f, 39.37f, 195.08f)
                    curveTo(39.8f, 195.9f, 40.06f, 196.82f, 40.16f, 197.87f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF340000), 0.66f to Color(0xFFD80004),
                        start = Offset(116.5f,215.0f), end = Offset(116.5f,186.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(42.58f, 209.0f)
                    verticalLineTo(195.91f)
                    horizontalLineTo(46.63f)
                    verticalLineTo(198.3f)
                    horizontalLineTo(46.76f)
                    curveTo(47.0f, 197.43f, 47.39f, 196.79f, 47.93f, 196.37f)
                    curveTo(48.47f, 195.94f, 49.1f, 195.73f, 49.81f, 195.73f)
                    curveTo(50.01f, 195.73f, 50.21f, 195.74f, 50.41f, 195.77f)
                    curveTo(50.62f, 195.8f, 50.81f, 195.83f, 50.98f, 195.88f)
                    verticalLineTo(199.51f)
                    curveTo(50.78f, 199.44f, 50.52f, 199.38f, 50.2f, 199.34f)
                    curveTo(49.88f, 199.3f, 49.6f, 199.28f, 49.35f, 199.28f)
                    curveTo(48.85f, 199.28f, 48.41f, 199.4f, 48.01f, 199.62f)
                    curveTo(47.62f, 199.83f, 47.31f, 200.14f, 47.08f, 200.53f)
                    curveTo(46.86f, 200.91f, 46.75f, 201.37f, 46.75f, 201.89f)
                    verticalLineTo(209.0f)
                    horizontalLineTo(42.58f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF340000), 0.66f to Color(0xFFD80004),
                        start = Offset(116.5f,215.0f), end = Offset(116.5f,186.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(58.12f, 209.25f)
                    curveTo(56.75f, 209.25f, 55.57f, 208.98f, 54.57f, 208.44f)
                    curveTo(53.59f, 207.89f, 52.82f, 207.12f, 52.29f, 206.11f)
                    curveTo(51.76f, 205.1f, 51.5f, 203.9f, 51.5f, 202.51f)
                    curveTo(51.5f, 201.15f, 51.76f, 199.97f, 52.3f, 198.96f)
                    curveTo(52.83f, 197.94f, 53.59f, 197.15f, 54.56f, 196.59f)
                    curveTo(55.53f, 196.02f, 56.67f, 195.74f, 57.99f, 195.74f)
                    curveTo(58.92f, 195.74f, 59.78f, 195.88f, 60.55f, 196.17f)
                    curveTo(61.32f, 196.46f, 61.99f, 196.89f, 62.55f, 197.46f)
                    curveTo(63.11f, 198.03f, 63.55f, 198.73f, 63.86f, 199.57f)
                    curveTo(64.18f, 200.4f, 64.33f, 201.35f, 64.33f, 202.42f)
                    verticalLineTo(203.46f)
                    horizontalLineTo(52.96f)
                    verticalLineTo(201.04f)
                    horizontalLineTo(60.46f)
                    curveTo(60.45f, 200.6f, 60.34f, 200.2f, 60.14f, 199.85f)
                    curveTo(59.94f, 199.51f, 59.65f, 199.24f, 59.3f, 199.05f)
                    curveTo(58.94f, 198.85f, 58.54f, 198.75f, 58.08f, 198.75f)
                    curveTo(57.61f, 198.75f, 57.19f, 198.85f, 56.82f, 199.06f)
                    curveTo(56.46f, 199.27f, 56.16f, 199.55f, 55.95f, 199.91f)
                    curveTo(55.73f, 200.26f, 55.62f, 200.66f, 55.61f, 201.11f)
                    verticalLineTo(203.57f)
                    curveTo(55.61f, 204.1f, 55.71f, 204.57f, 55.92f, 204.98f)
                    curveTo(56.13f, 205.38f, 56.43f, 205.68f, 56.82f, 205.91f)
                    curveTo(57.2f, 206.13f, 57.66f, 206.24f, 58.2f, 206.24f)
                    curveTo(58.57f, 206.24f, 58.9f, 206.19f, 59.2f, 206.09f)
                    curveTo(59.5f, 205.98f, 59.76f, 205.83f, 59.98f, 205.63f)
                    curveTo(60.19f, 205.43f, 60.36f, 205.19f, 60.46f, 204.9f)
                    lineTo(64.29f, 205.01f)
                    curveTo(64.13f, 205.87f, 63.78f, 206.62f, 63.24f, 207.25f)
                    curveTo(62.71f, 207.88f, 62.01f, 208.38f, 61.14f, 208.73f)
                    curveTo(60.27f, 209.07f, 59.26f, 209.25f, 58.12f, 209.25f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF340000), 0.66f to Color(0xFFD80004),
                        start = Offset(116.5f,215.0f), end = Offset(116.5f,186.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(70.15f, 209.22f)
                    curveTo(69.32f, 209.22f, 68.58f, 209.08f, 67.93f, 208.8f)
                    curveTo(67.29f, 208.52f, 66.78f, 208.09f, 66.4f, 207.53f)
                    curveTo(66.03f, 206.95f, 65.85f, 206.23f, 65.85f, 205.37f)
                    curveTo(65.85f, 204.64f, 65.98f, 204.03f, 66.23f, 203.53f)
                    curveTo(66.49f, 203.03f, 66.84f, 202.62f, 67.29f, 202.31f)
                    curveTo(67.74f, 202.0f, 68.25f, 201.76f, 68.84f, 201.6f)
                    curveTo(69.42f, 201.44f, 70.05f, 201.33f, 70.71f, 201.27f)
                    curveTo(71.46f, 201.2f, 72.06f, 201.13f, 72.51f, 201.06f)
                    curveTo(72.97f, 200.98f, 73.3f, 200.87f, 73.5f, 200.72f)
                    curveTo(73.71f, 200.58f, 73.82f, 200.37f, 73.82f, 200.1f)
                    verticalLineTo(200.06f)
                    curveTo(73.82f, 199.62f, 73.67f, 199.28f, 73.37f, 199.05f)
                    curveTo(73.06f, 198.81f, 72.66f, 198.69f, 72.15f, 198.69f)
                    curveTo(71.6f, 198.69f, 71.15f, 198.81f, 70.82f, 199.05f)
                    curveTo(70.48f, 199.28f, 70.27f, 199.61f, 70.18f, 200.03f)
                    lineTo(66.33f, 199.9f)
                    curveTo(66.45f, 199.1f, 66.74f, 198.39f, 67.21f, 197.77f)
                    curveTo(67.69f, 197.14f, 68.34f, 196.64f, 69.17f, 196.28f)
                    curveTo(70.01f, 195.92f, 71.01f, 195.74f, 72.18f, 195.74f)
                    curveTo(73.02f, 195.74f, 73.79f, 195.84f, 74.49f, 196.04f)
                    curveTo(75.19f, 196.23f, 75.81f, 196.51f, 76.33f, 196.89f)
                    curveTo(76.85f, 197.26f, 77.26f, 197.71f, 77.54f, 198.25f)
                    curveTo(77.83f, 198.79f, 77.98f, 199.41f, 77.98f, 200.1f)
                    verticalLineTo(209.0f)
                    horizontalLineTo(74.06f)
                    verticalLineTo(207.18f)
                    horizontalLineTo(73.95f)
                    curveTo(73.72f, 207.62f, 73.42f, 207.99f, 73.06f, 208.3f)
                    curveTo(72.7f, 208.61f, 72.28f, 208.84f, 71.79f, 208.99f)
                    curveTo(71.31f, 209.15f, 70.76f, 209.22f, 70.15f, 209.22f)
                    close()
                    moveTo(71.44f, 206.49f)
                    curveTo(71.89f, 206.49f, 72.29f, 206.4f, 72.65f, 206.22f)
                    curveTo(73.01f, 206.04f, 73.3f, 205.79f, 73.52f, 205.47f)
                    curveTo(73.73f, 205.15f, 73.84f, 204.77f, 73.84f, 204.35f)
                    verticalLineTo(203.1f)
                    curveTo(73.72f, 203.16f, 73.58f, 203.22f, 73.41f, 203.27f)
                    curveTo(73.24f, 203.32f, 73.06f, 203.37f, 72.86f, 203.42f)
                    curveTo(72.66f, 203.46f, 72.46f, 203.5f, 72.25f, 203.54f)
                    curveTo(72.04f, 203.57f, 71.84f, 203.6f, 71.64f, 203.63f)
                    curveTo(71.25f, 203.69f, 70.92f, 203.79f, 70.64f, 203.92f)
                    curveTo(70.37f, 204.05f, 70.15f, 204.22f, 70.01f, 204.43f)
                    curveTo(69.87f, 204.64f, 69.79f, 204.88f, 69.79f, 205.16f)
                    curveTo(69.79f, 205.6f, 69.95f, 205.93f, 70.25f, 206.15f)
                    curveTo(70.57f, 206.38f, 70.96f, 206.49f, 71.44f, 206.49f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF340000), 0.66f to Color(0xFFD80004),
                        start = Offset(116.5f,215.0f), end = Offset(116.5f,186.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(87.91f, 195.91f)
                    verticalLineTo(198.98f)
                    horizontalLineTo(79.65f)
                    verticalLineTo(195.91f)
                    horizontalLineTo(87.91f)
                    close()
                    moveTo(81.39f, 192.77f)
                    horizontalLineTo(85.55f)
                    verticalLineTo(204.88f)
                    curveTo(85.55f, 205.14f, 85.59f, 205.35f, 85.67f, 205.51f)
                    curveTo(85.76f, 205.66f, 85.88f, 205.77f, 86.04f, 205.84f)
                    curveTo(86.2f, 205.9f, 86.39f, 205.93f, 86.61f, 205.93f)
                    curveTo(86.77f, 205.93f, 86.94f, 205.92f, 87.11f, 205.89f)
                    curveTo(87.29f, 205.85f, 87.43f, 205.83f, 87.52f, 205.8f)
                    lineTo(88.15f, 208.81f)
                    curveTo(87.95f, 208.87f, 87.67f, 208.94f, 87.31f, 209.03f)
                    curveTo(86.95f, 209.11f, 86.52f, 209.16f, 86.02f, 209.19f)
                    curveTo(85.04f, 209.23f, 84.21f, 209.12f, 83.51f, 208.85f)
                    curveTo(82.81f, 208.57f, 82.28f, 208.14f, 81.91f, 207.55f)
                    curveTo(81.55f, 206.97f, 81.37f, 206.23f, 81.39f, 205.34f)
                    verticalLineTo(192.77f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF340000), 0.66f to Color(0xFFD80004),
                        start = Offset(116.5f,215.0f), end = Offset(116.5f,186.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(96.02f, 209.25f)
                    curveTo(94.65f, 209.25f, 93.47f, 208.98f, 92.47f, 208.44f)
                    curveTo(91.48f, 207.89f, 90.72f, 207.12f, 90.19f, 206.11f)
                    curveTo(89.66f, 205.1f, 89.4f, 203.9f, 89.4f, 202.51f)
                    curveTo(89.4f, 201.15f, 89.66f, 199.97f, 90.2f, 198.96f)
                    curveTo(90.73f, 197.94f, 91.48f, 197.15f, 92.46f, 196.59f)
                    curveTo(93.43f, 196.02f, 94.57f, 195.74f, 95.89f, 195.74f)
                    curveTo(96.82f, 195.74f, 97.67f, 195.88f, 98.45f, 196.17f)
                    curveTo(99.22f, 196.46f, 99.89f, 196.89f, 100.45f, 197.46f)
                    curveTo(101.01f, 198.03f, 101.45f, 198.73f, 101.76f, 199.57f)
                    curveTo(102.07f, 200.4f, 102.23f, 201.35f, 102.23f, 202.42f)
                    verticalLineTo(203.46f)
                    horizontalLineTo(90.85f)
                    verticalLineTo(201.04f)
                    horizontalLineTo(98.35f)
                    curveTo(98.35f, 200.6f, 98.24f, 200.2f, 98.04f, 199.85f)
                    curveTo(97.83f, 199.51f, 97.55f, 199.24f, 97.19f, 199.05f)
                    curveTo(96.84f, 198.85f, 96.44f, 198.75f, 95.98f, 198.75f)
                    curveTo(95.51f, 198.75f, 95.09f, 198.85f, 94.72f, 199.06f)
                    curveTo(94.35f, 199.27f, 94.06f, 199.55f, 93.85f, 199.91f)
                    curveTo(93.63f, 200.26f, 93.52f, 200.66f, 93.5f, 201.11f)
                    verticalLineTo(203.57f)
                    curveTo(93.5f, 204.1f, 93.61f, 204.57f, 93.82f, 204.98f)
                    curveTo(94.03f, 205.38f, 94.33f, 205.68f, 94.71f, 205.91f)
                    curveTo(95.1f, 206.13f, 95.56f, 206.24f, 96.1f, 206.24f)
                    curveTo(96.46f, 206.24f, 96.8f, 206.19f, 97.1f, 206.09f)
                    curveTo(97.4f, 205.98f, 97.66f, 205.83f, 97.88f, 205.63f)
                    curveTo(98.09f, 205.43f, 98.25f, 205.19f, 98.36f, 204.9f)
                    lineTo(102.19f, 205.01f)
                    curveTo(102.03f, 205.87f, 101.68f, 206.62f, 101.14f, 207.25f)
                    curveTo(100.61f, 207.88f, 99.9f, 208.38f, 99.04f, 208.73f)
                    curveTo(98.17f, 209.07f, 97.16f, 209.25f, 96.02f, 209.25f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF340000), 0.66f to Color(0xFFD80004),
                        start = Offset(116.5f,215.0f), end = Offset(116.5f,186.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(109.14f, 209.19f)
                    curveTo(108.18f, 209.19f, 107.3f, 208.94f, 106.51f, 208.44f)
                    curveTo(105.72f, 207.94f, 105.09f, 207.19f, 104.62f, 206.19f)
                    curveTo(104.14f, 205.19f, 103.91f, 203.95f, 103.91f, 202.46f)
                    curveTo(103.91f, 200.92f, 104.15f, 199.66f, 104.64f, 198.66f)
                    curveTo(105.13f, 197.67f, 105.77f, 196.93f, 106.56f, 196.46f)
                    curveTo(107.35f, 195.98f, 108.21f, 195.74f, 109.12f, 195.74f)
                    curveTo(109.81f, 195.74f, 110.4f, 195.86f, 110.89f, 196.1f)
                    curveTo(111.38f, 196.33f, 111.78f, 196.63f, 112.1f, 197.0f)
                    curveTo(112.42f, 197.37f, 112.66f, 197.75f, 112.82f, 198.15f)
                    horizontalLineTo(112.91f)
                    verticalLineTo(191.55f)
                    horizontalLineTo(117.08f)
                    verticalLineTo(209.0f)
                    horizontalLineTo(112.95f)
                    verticalLineTo(206.88f)
                    horizontalLineTo(112.82f)
                    curveTo(112.65f, 207.28f, 112.4f, 207.66f, 112.07f, 208.01f)
                    curveTo(111.75f, 208.36f, 111.34f, 208.65f, 110.85f, 208.86f)
                    curveTo(110.37f, 209.08f, 109.8f, 209.19f, 109.14f, 209.19f)
                    close()
                    moveTo(110.59f, 205.94f)
                    curveTo(111.1f, 205.94f, 111.53f, 205.8f, 111.89f, 205.51f)
                    curveTo(112.24f, 205.22f, 112.52f, 204.82f, 112.71f, 204.3f)
                    curveTo(112.91f, 203.77f, 113.0f, 203.16f, 113.0f, 202.46f)
                    curveTo(113.0f, 201.74f, 112.91f, 201.12f, 112.71f, 200.6f)
                    curveTo(112.53f, 200.09f, 112.25f, 199.69f, 111.89f, 199.41f)
                    curveTo(111.53f, 199.13f, 111.1f, 198.99f, 110.59f, 198.99f)
                    curveTo(110.07f, 198.99f, 109.64f, 199.14f, 109.28f, 199.42f)
                    curveTo(108.92f, 199.71f, 108.65f, 200.1f, 108.46f, 200.62f)
                    curveTo(108.28f, 201.14f, 108.19f, 201.75f, 108.19f, 202.46f)
                    curveTo(108.19f, 203.16f, 108.28f, 203.77f, 108.47f, 204.3f)
                    curveTo(108.66f, 204.82f, 108.93f, 205.22f, 109.28f, 205.51f)
                    curveTo(109.64f, 205.8f, 110.07f, 205.94f, 110.59f, 205.94f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF340000), 0.66f to Color(0xFFD80004),
                        start = Offset(116.5f,215.0f), end = Offset(116.5f,186.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(140.71f, 197.87f)
                    horizontalLineTo(136.45f)
                    curveTo(136.39f, 197.43f, 136.28f, 197.04f, 136.1f, 196.68f)
                    curveTo(135.93f, 196.33f, 135.69f, 196.03f, 135.4f, 195.78f)
                    curveTo(135.11f, 195.53f, 134.77f, 195.34f, 134.37f, 195.21f)
                    curveTo(133.98f, 195.07f, 133.54f, 195.01f, 133.07f, 195.01f)
                    curveTo(132.22f, 195.01f, 131.49f, 195.21f, 130.88f, 195.63f)
                    curveTo(130.27f, 196.04f, 129.8f, 196.64f, 129.47f, 197.43f)
                    curveTo(129.15f, 198.21f, 128.98f, 199.16f, 128.98f, 200.27f)
                    curveTo(128.98f, 201.43f, 129.15f, 202.4f, 129.48f, 203.19f)
                    curveTo(129.81f, 203.97f, 130.28f, 204.55f, 130.88f, 204.95f)
                    curveTo(131.49f, 205.34f, 132.21f, 205.54f, 133.04f, 205.54f)
                    curveTo(133.51f, 205.54f, 133.93f, 205.48f, 134.31f, 205.36f)
                    curveTo(134.7f, 205.24f, 135.04f, 205.07f, 135.32f, 204.84f)
                    curveTo(135.62f, 204.61f, 135.86f, 204.33f, 136.05f, 204.0f)
                    curveTo(136.24f, 203.66f, 136.38f, 203.28f, 136.45f, 202.86f)
                    lineTo(140.71f, 202.89f)
                    curveTo(140.64f, 203.66f, 140.41f, 204.42f, 140.04f, 205.17f)
                    curveTo(139.67f, 205.92f, 139.16f, 206.61f, 138.51f, 207.23f)
                    curveTo(137.87f, 207.84f, 137.07f, 208.33f, 136.14f, 208.69f)
                    curveTo(135.22f, 209.06f, 134.15f, 209.24f, 132.96f, 209.24f)
                    curveTo(131.38f, 209.24f, 129.96f, 208.89f, 128.71f, 208.2f)
                    curveTo(127.47f, 207.5f, 126.48f, 206.48f, 125.76f, 205.15f)
                    curveTo(125.04f, 203.81f, 124.68f, 202.19f, 124.68f, 200.27f)
                    curveTo(124.68f, 198.35f, 125.05f, 196.72f, 125.78f, 195.39f)
                    curveTo(126.51f, 194.05f, 127.5f, 193.04f, 128.75f, 192.35f)
                    curveTo(130.0f, 191.65f, 131.4f, 191.31f, 132.96f, 191.31f)
                    curveTo(134.01f, 191.31f, 134.99f, 191.46f, 135.89f, 191.75f)
                    curveTo(136.79f, 192.04f, 137.57f, 192.47f, 138.26f, 193.03f)
                    curveTo(138.94f, 193.59f, 139.49f, 194.27f, 139.92f, 195.08f)
                    curveTo(140.35f, 195.9f, 140.61f, 196.82f, 140.71f, 197.87f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF340000), 0.66f to Color(0xFFD80004),
                        start = Offset(116.5f,215.0f), end = Offset(116.5f,186.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(147.29f, 201.53f)
                    verticalLineTo(209.0f)
                    horizontalLineTo(143.13f)
                    verticalLineTo(191.55f)
                    horizontalLineTo(147.16f)
                    verticalLineTo(198.31f)
                    horizontalLineTo(147.3f)
                    curveTo(147.6f, 197.51f, 148.08f, 196.88f, 148.75f, 196.42f)
                    curveTo(149.43f, 195.97f, 150.25f, 195.74f, 151.23f, 195.74f)
                    curveTo(152.15f, 195.74f, 152.95f, 195.94f, 153.63f, 196.35f)
                    curveTo(154.32f, 196.76f, 154.84f, 197.33f, 155.22f, 198.07f)
                    curveTo(155.6f, 198.8f, 155.79f, 199.67f, 155.78f, 200.66f)
                    verticalLineTo(209.0f)
                    horizontalLineTo(151.61f)
                    verticalLineTo(201.47f)
                    curveTo(151.62f, 200.75f, 151.44f, 200.18f, 151.07f, 199.77f)
                    curveTo(150.7f, 199.36f, 150.18f, 199.16f, 149.51f, 199.16f)
                    curveTo(149.07f, 199.16f, 148.68f, 199.25f, 148.35f, 199.45f)
                    curveTo(148.02f, 199.63f, 147.76f, 199.9f, 147.57f, 200.26f)
                    curveTo(147.39f, 200.61f, 147.3f, 201.03f, 147.29f, 201.53f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF340000), 0.66f to Color(0xFFD80004),
                        start = Offset(116.5f,215.0f), end = Offset(116.5f,186.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(164.49f, 209.25f)
                    curveTo(163.12f, 209.25f, 161.94f, 208.97f, 160.95f, 208.4f)
                    curveTo(159.97f, 207.84f, 159.21f, 207.05f, 158.67f, 206.03f)
                    curveTo(158.15f, 205.02f, 157.88f, 203.84f, 157.88f, 202.5f)
                    curveTo(157.88f, 201.15f, 158.15f, 199.97f, 158.67f, 198.96f)
                    curveTo(159.21f, 197.94f, 159.97f, 197.15f, 160.95f, 196.59f)
                    curveTo(161.94f, 196.02f, 163.12f, 195.74f, 164.49f, 195.74f)
                    curveTo(165.87f, 195.74f, 167.05f, 196.02f, 168.03f, 196.59f)
                    curveTo(169.02f, 197.15f, 169.78f, 197.94f, 170.31f, 198.96f)
                    curveTo(170.84f, 199.97f, 171.11f, 201.15f, 171.11f, 202.5f)
                    curveTo(171.11f, 203.84f, 170.84f, 205.02f, 170.31f, 206.03f)
                    curveTo(169.78f, 207.05f, 169.02f, 207.84f, 168.03f, 208.4f)
                    curveTo(167.05f, 208.97f, 165.87f, 209.25f, 164.49f, 209.25f)
                    close()
                    moveTo(164.52f, 206.1f)
                    curveTo(165.02f, 206.1f, 165.44f, 205.95f, 165.79f, 205.64f)
                    curveTo(166.14f, 205.34f, 166.4f, 204.91f, 166.58f, 204.36f)
                    curveTo(166.77f, 203.82f, 166.86f, 203.19f, 166.86f, 202.47f)
                    curveTo(166.86f, 201.74f, 166.77f, 201.11f, 166.58f, 200.56f)
                    curveTo(166.4f, 200.02f, 166.14f, 199.59f, 165.79f, 199.28f)
                    curveTo(165.44f, 198.98f, 165.02f, 198.82f, 164.52f, 198.82f)
                    curveTo(164.0f, 198.82f, 163.57f, 198.98f, 163.21f, 199.28f)
                    curveTo(162.85f, 199.59f, 162.59f, 200.02f, 162.4f, 200.56f)
                    curveTo(162.22f, 201.11f, 162.13f, 201.74f, 162.13f, 202.47f)
                    curveTo(162.13f, 203.19f, 162.22f, 203.82f, 162.4f, 204.36f)
                    curveTo(162.59f, 204.91f, 162.85f, 205.34f, 163.21f, 205.64f)
                    curveTo(163.57f, 205.95f, 164.0f, 206.1f, 164.52f, 206.1f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF340000), 0.66f to Color(0xFFD80004),
                        start = Offset(116.5f,215.0f), end = Offset(116.5f,186.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(173.24f, 209.0f)
                    verticalLineTo(195.91f)
                    horizontalLineTo(177.29f)
                    verticalLineTo(198.3f)
                    horizontalLineTo(177.43f)
                    curveTo(177.67f, 197.43f, 178.05f, 196.79f, 178.6f, 196.37f)
                    curveTo(179.13f, 195.94f, 179.76f, 195.73f, 180.48f, 195.73f)
                    curveTo(180.67f, 195.73f, 180.87f, 195.74f, 181.07f, 195.77f)
                    curveTo(181.28f, 195.8f, 181.47f, 195.83f, 181.65f, 195.88f)
                    verticalLineTo(199.51f)
                    curveTo(181.45f, 199.44f, 181.19f, 199.38f, 180.86f, 199.34f)
                    curveTo(180.54f, 199.3f, 180.26f, 199.28f, 180.01f, 199.28f)
                    curveTo(179.52f, 199.28f, 179.07f, 199.4f, 178.67f, 199.62f)
                    curveTo(178.28f, 199.83f, 177.97f, 200.14f, 177.74f, 200.53f)
                    curveTo(177.52f, 200.91f, 177.41f, 201.37f, 177.41f, 201.89f)
                    verticalLineTo(209.0f)
                    horizontalLineTo(173.24f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF340000), 0.66f to Color(0xFFD80004),
                        start = Offset(116.5f,215.0f), end = Offset(116.5f,186.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(188.78f, 209.25f)
                    curveTo(187.41f, 209.25f, 186.23f, 208.98f, 185.24f, 208.44f)
                    curveTo(184.25f, 207.89f, 183.49f, 207.12f, 182.96f, 206.11f)
                    curveTo(182.43f, 205.1f, 182.16f, 203.9f, 182.16f, 202.51f)
                    curveTo(182.16f, 201.15f, 182.43f, 199.97f, 182.96f, 198.96f)
                    curveTo(183.5f, 197.94f, 184.25f, 197.15f, 185.22f, 196.59f)
                    curveTo(186.19f, 196.02f, 187.34f, 195.74f, 188.66f, 195.74f)
                    curveTo(189.59f, 195.74f, 190.44f, 195.88f, 191.21f, 196.17f)
                    curveTo(191.99f, 196.46f, 192.65f, 196.89f, 193.22f, 197.46f)
                    curveTo(193.78f, 198.03f, 194.22f, 198.73f, 194.53f, 199.57f)
                    curveTo(194.84f, 200.4f, 195.0f, 201.35f, 195.0f, 202.42f)
                    verticalLineTo(203.46f)
                    horizontalLineTo(183.62f)
                    verticalLineTo(201.04f)
                    horizontalLineTo(191.12f)
                    curveTo(191.11f, 200.6f, 191.01f, 200.2f, 190.8f, 199.85f)
                    curveTo(190.6f, 199.51f, 190.32f, 199.24f, 189.96f, 199.05f)
                    curveTo(189.61f, 198.85f, 189.2f, 198.75f, 188.74f, 198.75f)
                    curveTo(188.28f, 198.75f, 187.86f, 198.85f, 187.49f, 199.06f)
                    curveTo(187.12f, 199.27f, 186.83f, 199.55f, 186.61f, 199.91f)
                    curveTo(186.4f, 200.26f, 186.28f, 200.66f, 186.27f, 201.11f)
                    verticalLineTo(203.57f)
                    curveTo(186.27f, 204.1f, 186.38f, 204.57f, 186.59f, 204.98f)
                    curveTo(186.79f, 205.38f, 187.09f, 205.68f, 187.48f, 205.91f)
                    curveTo(187.87f, 206.13f, 188.33f, 206.24f, 188.86f, 206.24f)
                    curveTo(189.23f, 206.24f, 189.57f, 206.19f, 189.87f, 206.09f)
                    curveTo(190.17f, 205.98f, 190.43f, 205.83f, 190.64f, 205.63f)
                    curveTo(190.86f, 205.43f, 191.02f, 205.19f, 191.13f, 204.9f)
                    lineTo(194.96f, 205.01f)
                    curveTo(194.79f, 205.87f, 194.45f, 206.62f, 193.91f, 207.25f)
                    curveTo(193.37f, 207.88f, 192.67f, 208.38f, 191.8f, 208.73f)
                    curveTo(190.93f, 209.07f, 189.93f, 209.25f, 188.78f, 209.25f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF340000), 0.66f to Color(0xFFD80004),
                        start = Offset(116.5f,215.0f), end = Offset(116.5f,186.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(208.55f, 199.91f)
                    lineTo(204.73f, 200.01f)
                    curveTo(204.69f, 199.74f, 204.58f, 199.49f, 204.4f, 199.28f)
                    curveTo(204.23f, 199.07f, 204.0f, 198.9f, 203.71f, 198.78f)
                    curveTo(203.43f, 198.66f, 203.11f, 198.59f, 202.74f, 198.59f)
                    curveTo(202.26f, 198.59f, 201.85f, 198.69f, 201.51f, 198.88f)
                    curveTo(201.17f, 199.08f, 201.01f, 199.34f, 201.01f, 199.67f)
                    curveTo(201.01f, 199.92f, 201.11f, 200.15f, 201.32f, 200.33f)
                    curveTo(201.54f, 200.52f, 201.92f, 200.67f, 202.47f, 200.78f)
                    lineTo(204.99f, 201.26f)
                    curveTo(206.3f, 201.51f, 207.27f, 201.93f, 207.91f, 202.51f)
                    curveTo(208.55f, 203.09f, 208.87f, 203.85f, 208.88f, 204.81f)
                    curveTo(208.87f, 205.71f, 208.61f, 206.49f, 208.08f, 207.15f)
                    curveTo(207.55f, 207.82f, 206.84f, 208.33f, 205.93f, 208.7f)
                    curveTo(205.02f, 209.07f, 203.98f, 209.25f, 202.81f, 209.25f)
                    curveTo(200.94f, 209.25f, 199.47f, 208.86f, 198.39f, 208.1f)
                    curveTo(197.31f, 207.32f, 196.7f, 206.29f, 196.55f, 204.99f)
                    lineTo(200.66f, 204.89f)
                    curveTo(200.75f, 205.37f, 200.99f, 205.73f, 201.37f, 205.98f)
                    curveTo(201.75f, 206.23f, 202.24f, 206.36f, 202.83f, 206.36f)
                    curveTo(203.36f, 206.36f, 203.8f, 206.26f, 204.13f, 206.06f)
                    curveTo(204.47f, 205.86f, 204.64f, 205.6f, 204.64f, 205.27f)
                    curveTo(204.64f, 204.97f, 204.51f, 204.74f, 204.25f, 204.56f)
                    curveTo(203.99f, 204.38f, 203.59f, 204.24f, 203.05f, 204.13f)
                    lineTo(200.76f, 203.7f)
                    curveTo(199.45f, 203.46f, 198.48f, 203.02f, 197.83f, 202.38f)
                    curveTo(197.19f, 201.73f, 196.87f, 200.91f, 196.88f, 199.91f)
                    curveTo(196.87f, 199.03f, 197.11f, 198.28f, 197.58f, 197.66f)
                    curveTo(198.05f, 197.04f, 198.72f, 196.56f, 199.59f, 196.23f)
                    curveTo(200.46f, 195.9f, 201.48f, 195.74f, 202.67f, 195.74f)
                    curveTo(204.44f, 195.74f, 205.84f, 196.11f, 206.86f, 196.85f)
                    curveTo(207.88f, 197.59f, 208.45f, 198.61f, 208.55f, 199.91f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFFFEFEF)), stroke = null, fillAlpha = 0.35f,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(69.0f, 148.0f)
                    arcToRelative(50.5f, 6.0f, 0.0f, true, false, 101.0f, 0.0f)
                    arcToRelative(50.5f, 6.0f, 0.0f, true, false, -101.0f, 0.0f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xD3FFFFFF), 1.0f to Color(0x00737373),
                        start = Offset(119.0f,45.5f), end = Offset(119.0f,150.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(86.0f, 43.25f)
                    lineTo(152.0f, 43.25f)
                    arcTo(12.0f, 12.0f, 0.0f, false, true, 164.0f, 55.25f)
                    lineTo(164.0f, 125.0f)
                    arcTo(12.0f, 12.0f, 0.0f, false, true, 152.0f, 137.0f)
                    lineTo(86.0f, 137.0f)
                    arcTo(12.0f, 12.0f, 0.0f, false, true, 74.0f, 125.0f)
                    lineTo(74.0f, 55.25f)
                    arcTo(12.0f, 12.0f, 0.0f, false, true, 86.0f, 43.25f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFD80004)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(74.0f, 55.19f)
                    curveTo(74.0f, 48.56f, 79.37f, 43.19f, 86.0f, 43.19f)
                    horizontalLineTo(152.0f)
                    curveTo(158.63f, 43.19f, 164.0f, 48.56f, 164.0f, 55.19f)
                    verticalLineTo(56.99f)
                    horizontalLineTo(74.0f)
                    verticalLineTo(55.19f)
                    close()
                }
                path(fill = radialGradient(0.0f to Color(0x00ED3AF3), 1.0f to Color(0x42000000),
                        center = Offset(119.0f,50.09f), radius = 40.42f), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(74.0f, 55.19f)
                    curveTo(74.0f, 48.56f, 79.37f, 43.19f, 86.0f, 43.19f)
                    horizontalLineTo(152.0f)
                    curveTo(158.63f, 43.19f, 164.0f, 48.56f, 164.0f, 55.19f)
                    verticalLineTo(56.99f)
                    horizontalLineTo(74.0f)
                    verticalLineTo(55.19f)
                    close()
                }
            }
            group {
                path(fill = SolidColor(Color(0xFFffffff)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(89.91f, 49.85f)
                    arcToRelative(4.11f, 4.28f, 0.0f, true, false, 8.22f, 0.0f)
                    arcToRelative(4.11f, 4.28f, 0.0f, true, false, -8.22f, 0.0f)
                    close()
                }
                path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(90.83f, 49.85f)
                    arcToRelative(3.2f, 3.33f, 0.0f, true, false, 6.4f, 0.0f)
                    arcToRelative(3.2f, 3.33f, 0.0f, true, false, -6.4f, 0.0f)
                    close()
                }
                path(fill = radialGradient(0.27f to Color(0xFFD9D9D9), 0.64f to Color(0xFFA6A6A6),
                        1.0f to Color(0xFF737373), center = Offset(94.03f,44.85f), radius = 7.85f),
                        stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin
                        = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(94.03f, 37.0f)
                    lineTo(94.03f, 37.0f)
                    arcTo(2.74f, 2.74f, 0.0f, false, true, 96.77f, 39.74f)
                    lineTo(96.77f, 49.96f)
                    arcTo(2.74f, 2.74f, 0.0f, false, true, 94.03f, 52.7f)
                    lineTo(94.03f, 52.7f)
                    arcTo(2.74f, 2.74f, 0.0f, false, true, 91.28f, 49.96f)
                    lineTo(91.28f, 39.74f)
                    arcTo(2.74f, 2.74f, 0.0f, false, true, 94.03f, 37.0f)
                    close()
                }
            }
            group {
                path(fill = SolidColor(Color(0xFFffffff)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(140.17f, 49.85f)
                    arcToRelative(4.11f, 4.28f, 0.0f, true, false, 8.22f, 0.0f)
                    arcToRelative(4.11f, 4.28f, 0.0f, true, false, -8.22f, 0.0f)
                    close()
                }
                path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(141.08f, 49.85f)
                    arcToRelative(3.2f, 3.33f, 0.0f, true, false, 6.4f, 0.0f)
                    arcToRelative(3.2f, 3.33f, 0.0f, true, false, -6.4f, 0.0f)
                    close()
                }
                path(fill = radialGradient(0.27f to Color(0xFFD9D9D9), 0.64f to Color(0xFFA6A6A6),
                        1.0f to Color(0xFF737373), center = Offset(144.28f,44.85f), radius = 7.85f),
                        stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin
                        = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(144.28f, 37.0f)
                    lineTo(144.28f, 37.0f)
                    arcTo(2.74f, 2.74f, 0.0f, false, true, 147.02f, 39.74f)
                    lineTo(147.02f, 49.96f)
                    arcTo(2.74f, 2.74f, 0.0f, false, true, 144.28f, 52.7f)
                    lineTo(144.28f, 52.7f)
                    arcTo(2.74f, 2.74f, 0.0f, false, true, 141.54f, 49.96f)
                    lineTo(141.54f, 39.74f)
                    arcTo(2.74f, 2.74f, 0.0f, false, true, 144.28f, 37.0f)
                    close()
                }
                path(fill = linearGradient(0.34f to Color(0xFFD80004), 1.0f to Color(0xFF340000),
                        start = Offset(120.0f,76.0f), end = Offset(120.0f,115.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(101.48f, 83.73f)
                    verticalLineTo(107.0f)
                    horizontalLineTo(95.86f)
                    verticalLineTo(88.98f)
                    horizontalLineTo(95.73f)
                    lineTo(90.52f, 92.16f)
                    verticalLineTo(87.3f)
                    lineTo(96.26f, 83.73f)
                    horizontalLineTo(101.48f)
                    close()
                }
                path(fill = linearGradient(0.34f to Color(0xFFD80004), 1.0f to Color(0xFF340000),
                        start = Offset(120.0f,76.0f), end = Offset(120.0f,115.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(116.25f, 107.57f)
                    curveTo(114.22f, 107.57f, 112.47f, 107.09f, 111.0f, 106.13f)
                    curveTo(109.53f, 105.15f, 108.39f, 103.76f, 107.6f, 101.96f)
                    curveTo(106.8f, 100.14f, 106.41f, 97.95f, 106.42f, 95.4f)
                    curveTo(106.43f, 92.84f, 106.82f, 90.68f, 107.61f, 88.9f)
                    curveTo(108.41f, 87.11f, 109.54f, 85.75f, 111.0f, 84.82f)
                    curveTo(112.47f, 83.88f, 114.22f, 83.41f, 116.25f, 83.41f)
                    curveTo(118.28f, 83.41f, 120.03f, 83.88f, 121.5f, 84.82f)
                    curveTo(122.97f, 85.75f, 124.11f, 87.11f, 124.91f, 88.9f)
                    curveTo(125.7f, 90.69f, 126.1f, 92.85f, 126.09f, 95.4f)
                    curveTo(126.09f, 97.96f, 125.69f, 100.15f, 124.89f, 101.97f)
                    curveTo(124.1f, 103.78f, 122.97f, 105.17f, 121.5f, 106.14f)
                    curveTo(120.04f, 107.09f, 118.29f, 107.57f, 116.25f, 107.57f)
                    close()
                    moveTo(116.25f, 102.97f)
                    curveTo(117.46f, 102.97f, 118.44f, 102.35f, 119.19f, 101.11f)
                    curveTo(119.94f, 99.87f, 120.31f, 97.97f, 120.3f, 95.4f)
                    curveTo(120.3f, 93.72f, 120.13f, 92.33f, 119.79f, 91.24f)
                    curveTo(119.45f, 90.14f, 118.98f, 89.32f, 118.37f, 88.78f)
                    curveTo(117.77f, 88.25f, 117.06f, 87.98f, 116.25f, 87.98f)
                    curveTo(115.04f, 87.98f, 114.07f, 88.59f, 113.33f, 89.81f)
                    curveTo(112.58f, 91.02f, 112.21f, 92.88f, 112.2f, 95.4f)
                    curveTo(112.19f, 97.1f, 112.36f, 98.52f, 112.69f, 99.64f)
                    curveTo(113.03f, 100.76f, 113.51f, 101.6f, 114.12f, 102.15f)
                    curveTo(114.74f, 102.69f, 115.44f, 102.97f, 116.25f, 102.97f)
                    close()
                }
                path(fill = linearGradient(0.34f to Color(0xFFD80004), 1.0f to Color(0xFF340000),
                        start = Offset(120.0f,76.0f), end = Offset(120.0f,115.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(138.93f, 107.57f)
                    curveTo(136.9f, 107.57f, 135.15f, 107.09f, 133.68f, 106.13f)
                    curveTo(132.21f, 105.15f, 131.08f, 103.76f, 130.29f, 101.96f)
                    curveTo(129.49f, 100.14f, 129.1f, 97.95f, 129.1f, 95.4f)
                    curveTo(129.11f, 92.84f, 129.51f, 90.68f, 130.3f, 88.9f)
                    curveTo(131.09f, 87.11f, 132.22f, 85.75f, 133.68f, 84.82f)
                    curveTo(135.15f, 83.88f, 136.9f, 83.41f, 138.93f, 83.41f)
                    curveTo(140.96f, 83.41f, 142.71f, 83.88f, 144.18f, 84.82f)
                    curveTo(145.66f, 85.75f, 146.8f, 87.11f, 147.59f, 88.9f)
                    curveTo(148.39f, 90.69f, 148.78f, 92.85f, 148.78f, 95.4f)
                    curveTo(148.78f, 97.96f, 148.38f, 100.15f, 147.58f, 101.97f)
                    curveTo(146.79f, 103.78f, 145.65f, 105.17f, 144.18f, 106.14f)
                    curveTo(142.72f, 107.09f, 140.97f, 107.57f, 138.93f, 107.57f)
                    close()
                    moveTo(138.93f, 102.97f)
                    curveTo(140.15f, 102.97f, 141.13f, 102.35f, 141.88f, 101.11f)
                    curveTo(142.63f, 99.87f, 143.0f, 97.97f, 142.99f, 95.4f)
                    curveTo(142.99f, 93.72f, 142.82f, 92.33f, 142.48f, 91.24f)
                    curveTo(142.14f, 90.14f, 141.67f, 89.32f, 141.06f, 88.78f)
                    curveTo(140.45f, 88.25f, 139.74f, 87.98f, 138.93f, 87.98f)
                    curveTo(137.73f, 87.98f, 136.76f, 88.59f, 136.01f, 89.81f)
                    curveTo(135.27f, 91.02f, 134.9f, 92.88f, 134.89f, 95.4f)
                    curveTo(134.88f, 97.1f, 135.04f, 98.52f, 135.38f, 99.64f)
                    curveTo(135.72f, 100.76f, 136.2f, 101.6f, 136.81f, 102.15f)
                    curveTo(137.42f, 102.69f, 138.13f, 102.97f, 138.93f, 102.97f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF340000), 0.73f to Color(0xFFD80004),
                        start = Offset(137.5f,111.5f), end = Offset(158.0f,131.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(147.33f, 117.0f)
                    curveTo(147.33f, 115.89f, 148.23f, 115.0f, 149.33f, 115.0f)
                    horizontalLineTo(150.67f)
                    curveTo(151.77f, 115.0f, 152.67f, 115.89f, 152.67f, 117.0f)
                    verticalLineTo(129.0f)
                    curveTo(152.67f, 130.1f, 151.77f, 131.0f, 150.67f, 131.0f)
                    horizontalLineTo(149.33f)
                    curveTo(148.23f, 131.0f, 147.33f, 130.1f, 147.33f, 129.0f)
                    verticalLineTo(117.0f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF340000), 0.73f to Color(0xFFD80004),
                        start = Offset(137.5f,111.5f), end = Offset(158.0f,131.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(156.0f, 120.33f)
                    curveTo(157.1f, 120.33f, 158.0f, 121.23f, 158.0f, 122.33f)
                    verticalLineTo(123.67f)
                    curveTo(158.0f, 124.77f, 157.1f, 125.67f, 156.0f, 125.67f)
                    lineTo(144.0f, 125.67f)
                    curveTo(142.9f, 125.67f, 142.0f, 124.77f, 142.0f, 123.67f)
                    lineTo(142.0f, 122.33f)
                    curveTo(142.0f, 121.23f, 142.9f, 120.33f, 144.0f, 120.33f)
                    lineTo(156.0f, 120.33f)
                    close()
                }
            }
        }
        .build()
        return _created100Achievement!!
    }

private var _created100Achievement: ImageVector? = null
